import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Alert, Box, Typography } from '@mui/material';

/**
 * ProtectedBranchRoute - Mengecek tipe cabang pengguna sebelum mengakses halaman
 * @param {string} requiredBranchType - Tipe cabang yang diizinkan (e.g., 'cafe', 'retail/toko')
 * @param {React.ReactNode} children - Komponen yang akan di-render jika authorized
 */
const ProtectedBranchRoute = ({ requiredBranchType, children }) => {
  const authUser = useSelector((state) => state.auth.user);
  const location = useLocation();

  // Ambil tipe cabang dari user
  const userBranchType = authUser?.cabang?.tipe_cabang || '';

  // Jika user belum login, redirect ke login
  if (!authUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Jika branch type tidak ada, redirect ke main kasir
  if (!userBranchType) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          <Typography variant="body2">
            Tipe cabang tidak ditemukan. Silakan cek konfigurasi akun Anda.
          </Typography>
        </Alert>
      </Box>
    );
  }

  // Jika user mencoba akses cabang yang berbeda, tampilkan error
  if (userBranchType !== requiredBranchType) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          <Typography variant="h6" sx={{ mb: 1 }}>Akses Ditolak</Typography>
          <Typography variant="body2">
            Anda terdaftar sebagai kasir <strong>{userBranchType === 'cafe' ? 'Cafe' : 'Retail/Toko'}</strong>.
            Halaman ini hanya dapat diakses oleh kasir <strong>{requiredBranchType === 'cafe' ? 'Cafe' : 'Retail/Toko'}</strong>.
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
            Silakan hubungi administrator jika ada kesalahan.
          </Typography>
        </Alert>
      </Box>
    );
  }
  return children;
};

export default ProtectedBranchRoute;
